import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { AddModelButton, DataTable, DeleteModelButton, EditModelButton, GeneralFormSelectOption, Panel, Toolbar } from '@lib/ui-components';

export const CommunesPage = () => {
  const { t } = useTranslation();
  const [tableReloadKey, setTableReloadKey] = React.useState(1);

  const communesSelectOptions: GeneralFormSelectOption[] = [
    { label: 'Bjelovar-Bilogora', value: 'Bjelovar-Bilogora' },
    { label: 'Brod-Posavina', value: 'Brod-Posavina' },
    { label: 'Dubrovnik-Neretva', value: 'Dubrovnik-Neretva' },
    { label: 'Istria', value: 'Istria' },
    { label: 'Karlovac', value: 'Karlovac' },
    { label: 'Koprivnica-Križevci', value: 'Koprivnica-Križevci' },
    { label: 'Krapina-Zagorje', value: 'Krapina-Zagorje' },
    { label: 'Lika-Senj', value: 'Lika-Senj' },
    { label: 'Međimurje', value: 'Međimurje' },
    { label: 'Osijek-Baranja', value: 'Osijek-Baranja' },
    { label: 'Požega-Slavonia', value: 'Požega-Slavonia' },
    { label: 'Primorje-Gorski Kotar', value: 'Primorje-Gorski Kotar' },
    { label: 'Šibenik-Knin', value: 'Šibenik-Knin' },
    { label: 'Sisak-Moslavina', value: 'Sisak-Moslavina' },
    { label: 'Split-Dalmatia', value: 'Split-Dalmatia' },
    { label: 'Varaždin', value: 'Varaždin' },
    { label: 'Virovitica-Podravina', value: 'Virovitica-Podravina' },
    { label: 'Vukovar-Syrmia', value: 'Vukovar-Syrmia' },
    { label: 'Zadar', value: 'Zadar' },
    { label: 'Zagreb', value: 'Zagreb' },
    { label: 'Grad Zagreb', value: 'Grad Zagreb' },
  ];

  const rightButtons: JSX.Element[] = [
    <AddModelButton key='add-model-button-35'
      url='/api/resource/communes'
      buttonLabel={t('add')}
      dialogTitle={t('commune')}
      fields={[
        { field: 'name', label: t('commune'), type: 'text' },
        { field: 'province', label: t('province'), type: 'select', selectOptions: communesSelectOptions },
      ]}
      validationSchema={{
        name: Yup.string().required(t('requiredField')),
        province: Yup.string().required(t('requiredField')),
      }}
      onSaved={async () => setTableReloadKey(tableReloadKey + 1)}
      postErrorMappings={{
        '400': t('Error.CommuneExists'),
      }}
    />,
  ];

  return (
    <Panel header={t('communes')} borderType='raised'>
      <Toolbar right={rightButtons} />
      <DataTable
        rowLink={{ linkPath: '' }}
        refreshKey={tableReloadKey}
        fetchUrl={'/api/resource/communes'}
        columns={[
          {
            key: 'name',
            label: t('commune'),
            type: 'text',
          },
          {
            key: 'province',
            label: t('province'),
            type: 'text',
          },
        ]}
        rowOptions={[
          {
            renderer: (row) => (
              <EditModelButton
                id={row['id']}
                entity={row}
                url='/api/resource/communes'
                buttonLabel={t('edit')}
                dialogTitle={t('commune')}
                fields={[
                  { field: 'name', label: t('commune'), type: 'text' },
                  { field: 'province', label: t('province'), type: 'select', selectOptions: communesSelectOptions },
                ]}
                validationSchema={{
                  name: Yup.string().required(t('requiredField')),
                  province: Yup.string().required(t('requiredField')),
                }}
                onSaved={async () => setTableReloadKey(tableReloadKey + 1)}
                yellowIcon
                postErrorMappings={{
                  '400': t('Error.CommuneExists'),
                }}
              />
            ),
          },
          {
            renderer: (row) => (
              <DeleteModelButton
                id={row['id']}
                url='/api/resource/communes'
                onDeleted={async () => setTableReloadKey(tableReloadKey + 1)}
                postErrorMappings={{
                  '400': t('Error.CommuneUsed'),
                }}
              />
            ),
          },
        ]}
      />
    </Panel>
  );
};
